/* eslint-disable */

import React, { useState, useContext } from 'react';
import {
  Drawer,
  Avatar,
  Box,
  Divider,
  Stack,
  Typography,
  List,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
  Menu,
  MenuItem,
  ListItemButton,
  Hidden,
} from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import { ExpandLess, ExpandMore, MoreVert, Logout } from '@mui/icons-material';
import HistoryIcon from '@mui/icons-material/History';
import DescriptionIcon from '@mui/icons-material/Description';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';

import { PassportAuth } from '../../contexts/AuthContext';
import { getStorage } from '../../utils/functions/localstorage';
import { getEmail } from '../../utils/functions/accessRight';

const drawerWidth = 240;

const menuItems = [
  {
    href: '/CreatePayment',
    icon: AccountBalanceIcon,
    title: 'สร้างรายการชำระเงิน',
    sub: [],
  },
  {
    href: '/History',
    icon: HistoryIcon,
    title: 'ประวัติการทำรายการ',
    sub: [],
  },
  {
    href: '',
    icon: ManageAccountsIcon,
    title: 'การจัดการบัญชีผู้ใช้งาน',
    sub: [
      {
        href: '/ManagementSuperAdminEEntry',
        icon: PersonIcon,
        title: 'SuperAdmin',
      },
      {
        href: '/ManagementAdminEEntry',
        icon: PersonIcon,
        title: 'Admin',
      },
    ],
  },
  {
    href: '/Config',
    icon: SettingsIcon,
    title: 'การตั้งค่า',
    sub: [],
  },
];

export default function SidebarSuperAdminEEntryNewDesign({
  openMobile,
  onMobileClose,
  open = true,
  setOpen = () => {},
  children,
}) {
  const location = useLocation();
  const { handleSignout } = useContext(PassportAuth);
  const [openSubmenus, setOpenSubmenus] = useState([]);
  const [menuAnchor, setMenuAnchor] = useState(null);

  const userName = getStorage('username');
  const email = getEmail();
  console.log('email', email);

  const isMenuOpen = Boolean(menuAnchor);

  const handleToggle = (title) => {
    setOpenSubmenus((prev) =>
      prev.includes(title) ? prev.filter((t) => t !== title) : [...prev, title],
    );
  };

  const isOpen = (title) => openSubmenus.includes(title);

  const renderMenu = (items, level = 0) =>
    items.map((item, index) => {
      const hasSub = item.sub && item.sub.length > 0;
      const Icon = item.icon;

      return (
        <Box key={`${item.title}-${index}`}>
          {!hasSub && item.href ? (
            <NavLink
              to={item.href}
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <ListItemButton
                selected={location.pathname.startsWith(item.href)}
                sx={{
                  pl: 2 + level * 2,
                  borderRadius: '12px', // ความโค้งของปุ่ม
                  mx: 1, // เพิ่ม margin ซ้าย-ขวาให้ดูมน
                  '&.Mui-selected': {
                    backgroundColor: '#007CC2',
                    color: '#fff',
                    '& .MuiListItemIcon-root': {
                      color: '#fff',
                    },
                  },
                  '&.Mui-selected:hover': {
                    backgroundColor: '#0062a8', // สีตอน hover (เข้มขึ้นนิด)
                  },
                }}
              >
                <ListItemIcon>
                  <Icon />
                </ListItemIcon>
                <ListItemText primary={item.title} />
              </ListItemButton>
            </NavLink>
          ) : (
            <>
              <ListItemButton
                onClick={() => handleToggle(item.title)}
                sx={{ pl: 3 + level * 2 }}
              >
                <ListItemIcon>
                  <Icon />
                </ListItemIcon>
                <ListItemText primary={item.title} />
                {isOpen(item.title) ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={isOpen(item.title)} timeout="auto" unmountOnExit>
                <List>{renderMenu(item.sub, level + 1)}</List>
              </Collapse>
            </>
          )}
        </Box>
      );
    });

  const userInfo = (
    <Stack
      direction="row"
      sx={{
        p: 2,
        gap: 1,
        alignItems: 'center',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Avatar sx={{ width: 36, height: 36 }}>{userName.charAt(0)}</Avatar>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="body2" fontWeight={500}>
          {userName}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {email}
        </Typography>
      </Box>
      <IconButton size="small" onClick={(e) => setMenuAnchor(e.currentTarget)}>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={menuAnchor}
        open={isMenuOpen}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        PaperProps={{
          sx: {
            mb: 1,
            minWidth: 160,
            borderRadius: 2,
            boxShadow: '0px 4px 10px rgba(0,0,0,0.15)',
          },
        }}
      >
        <MenuItem onClick={handleSignout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          ออกจากระบบ
        </MenuItem>
      </Menu>
    </Stack>
  );

  const drawerContent = (
    <>
      <Divider />
      <List>{renderMenu(menuItems)}</List>
      <Box sx={{ flexGrow: 1 }} />
      {userInfo}
    </>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Desktop Sidebar */}
      <Hidden mdDown>
        <Drawer
          variant="permanent"
          open={open}
          sx={{
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              boxSizing: 'border-box',
              overflowY: 'auto',
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: '#f0f0f0',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#b0b0b0',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#888',
              },
            },
          }}
        >
          {drawerContent}
        </Drawer>
      </Hidden>

      {/* Mobile Sidebar */}
      <Hidden mdUp>
        <Drawer
          variant="temporary"
          open={openMobile}
          onClose={onMobileClose}
          ModalProps={{ keepMounted: true }}
          sx={{
            '& .MuiDrawer-paper': {
              width: drawerWidth,
            },
          }}
        >
          {/* <Box display="flex" justifyContent="flex-end" p={2}>
            <IconButton onClick={onMobileClose}>
              <Close />
            </IconButton>
          </Box> */}
          {drawerContent}
        </Drawer>
      </Hidden>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { md: `calc(100% - ${drawerWidth}px)` }, // ทำให้เนื้อหากว้างถูกต้อง
          ml: { md: `${drawerWidth}px` }, // ขยับเนื้อหาให้พอดีกับ Sidebar
          overflowX: 'auto',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
